module.exports = __webpack_public_path__ + "media/39.004db95b.mp3";